import * as React from "react";
import { styled } from "@mui/material/styles";
import Editor from "../editor/Editor";
import { inject } from "mobx-react";
import { observer } from "mobx-react";

import Modal from "react-modal";
import autobind from "autobind-decorator";

const ModalErrorHeader = styled("h1")({
  fontSize: "16px",
  color: "rgb(80, 80, 80)",
  userSelect: "none",
  textAlign: "center",
});

const ModalErrorPara = styled("p")({
  marginTop: "12px",
  marginBottom: "12px",
  fontSize: "14px",
  color: "rgb(120, 120, 120)",
  textAlign: "center",
});

const OkButton = styled("button")({
  width: "64px",
  lineHeight: "28px",
  height: "28px",
  fontSize: "12px",
  background: "rgb(155, 66, 227)",
  color: "white",
  cursor: "pointer",
  borderRadius: "4px",
  outline: "none",
  border: "none",
  transition: "all 100ms ease-in-out",
  textAlign: "center",
});

type ErrorModalProps = {
  editor?: Editor;
  className?: string;
  style?: React.CSSProperties;
};

@inject("editor")
@observer
export default class ErrorModal extends React.Component<ErrorModalProps> {
  modalContainer = null;

  @autobind
  removeError() {
    this.props.editor.setError(null);
  }

  render() {
    var { editor } = this.props;

    if (this.modalContainer == null) {
      this.modalContainer = document.getElementById("app-content");
    }

    return (
      <Modal
        style={{
          overlay: {
            outline: "none",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.6)",
          },
          content: {
            background: "rgb(240, 240, 240)",
            width: "420px",
            borderRadius: "4px",
            padding: "24px",
            maxHeight: "60%",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          },
        }}
        isOpen={editor.error.title != ""}
        appElement={this.modalContainer}
        onRequestClose={this.removeError}
      >
        <ModalErrorHeader> {editor.error.title} </ModalErrorHeader>
        <ModalErrorPara> {editor.error.value} </ModalErrorPara>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "18px",
          }}
        >
          <OkButton onClick={this.removeError}> OK </OkButton>
        </div>
      </Modal>
    );
  }
}
